/**
 * patrol-building-search-view.js
 */

import React from 'react';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import { PatrolTypeTitle } from '../../training-utils';


export default function PatrolBuildingSearchView(props) {
  const { record, patrolTypes } = props;
  const buildingSearch = record.buildingSearch;

  return (
    <>
      {record &&
      <IconSection iconName='patrol-building-search'>
        <PatrolTypeTitle 
          patrolType={record.type} 
          patrolTypes={patrolTypes} 
          step={record.order}
        />

        <InfoRow title='Monitor' text={buildingSearch.monitor} />
        <InfoRow title='Controlled Negative' text={buildingSearch.isControlledNegative ? 'Yes' : 'No'} />
        <InfoRow title='Building Types' text={buildingSearch.types.map(type => type.customOtherName || type.name).join(', ')} />
        {buildingSearch.areaSize && buildingSearch.areaSizeUnit &&
        <InfoRow title='Area Size' text={`${buildingSearch.areaSize} ${buildingSearch.areaSizeUnit.name}`} />}
        <InfoRow title='Decoy Count' text={buildingSearch.decoyCount} />
      </IconSection>}
    </>
  );
}